import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, Kamitaku } from "@/mixins/index";
import { dailyTaskFlowPercent } from "@/api/kamitaku/kamitaku";
import * as list from "C:/Users/Administrator/AppData/Local/Microsoft/TypeScript/5.4/node_modules/postcss/lib/list";
export default {
  name: "kamitakuCheckpoint",
  mixins: [tabulation, Kamitaku],
  data: function data() {
    return {
      reqFn: dailyTaskFlowPercent,
      searchData: {
        tasks: '',
        is_new_register: 1,
        system_info: ''
      },
      Calculation: [{
        label: this.$t('personCount'),
        value: 'task_pnum'
      }, {
        label: this.$t('roiPercent'),
        value: 'task_percent'
      }],
      CalculationValue: 'task_pnum',
      StatisticalContent: [{
        label: this.$t('overallFlow'),
        value: '1'
      }, {
        label: this.$t('singleFlowStepLoss'),
        value: '2'
      }],
      userTypes: [{
        label: this.$t('newRegisterUser'),
        value: 1
      }, {
        label: this.$t('activeUsers'),
        value: 2
      }, {
        label: this.$t('newAndPayUser'),
        value: 3
      }, {
        label: this.$t('newNotPayUser'),
        value: 4
      }],
      devisionList: [{
        label: this.$t('android'),
        value: 'android'
      }, {
        label: "IOS",
        value: 'ios'
      }, {
        label: "windows",
        value: 'windows'
      }, {
        label: "mac",
        value: 'mac'
      }],
      StatisticalContentValue: '1',
      totalDynamic: [],
      totalDynamicValue: [],
      Dynamic: [],
      data_type: 'daily-task',
      more: true,
      searchUserType: this.$t('newRegisterUser'),
      d: require('./role-18-s1.json')
    };
  },
  created: function created() {// this.jisuan()
  },
  watch: {
    'searchData.country': {
      deep: true,
      handler: function handler(newVal, oldVal) {
        this.totalDynamicValue = [];
        this.searchData.tasks = '';
      }
    }
  },
  methods: {
    jisuan: function jisuan() {
      var list = [];
      var columns = [];
      var datas = {};

      for (var k in this.d) {
        var data = {
          num: 0,
          subscript: 0
        };

        for (var j in this.d[k]) {
          data.num = this.d[k][j].duration + data.num;
          data.subscript = data.subscript + 1;
        }

        datas['Average' + k] = (data.num / data.subscript / 60).toFixed(2);
        columns.push({
          label: 'Average' + k,
          prop: 'Average' + k
        });
      }

      this.$export.excel({
        columns: columns,
        data: [datas],
        title: this.$route.meta.title
      });
    },
    totalDynamicChange: function totalDynamicChange(e) {
      var list = [];
      this.totalDynamic.forEach(function (item, index) {
        e.forEach(function (items, indexs) {
          if (item.value == items) {
            list.push(item.tag);
          }
        });
      });
      this.searchData.tasks = list.toString();
    },
    userTypeChange: function userTypeChange() {
      this.searchData.tasks = '';
    },
    getListnew: function getListnew() {
      var _this = this;

      this.getList( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var total_data, dataValue, allData, list, key, data, key1, checkpoint;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // this.totalDynamic = []
                  _this.tableData = [];
                  _this.Dynamic = []; // await this.getgTaskDescDesc()

                  _this.searchUserType = _this.userTypes.find(function (i) {
                    return i.value == _this.searchData.is_new_register;
                  }).label;
                  total_data = res.total_data;
                  total_data.loss_task_percent = total_data.loss_percent;
                  total_data.task_percent = total_data.percent;
                  dataValue = '';

                  if (_this.StatisticalContentValue == 1) {
                    dataValue = _this.CalculationValue;
                  } else {
                    dataValue = 'loss_task_percent';
                  }

                  res.all_keys.forEach(function (i) {
                    var checkpoint = i.substring(i.indexOf(':') + 1, i.indexOf(':', i.indexOf(':') + 1));

                    _this.Dynamic.push({
                      label: checkpoint,
                      value: 'n' + checkpoint,
                      tag: i
                    });
                  });
                  allData = []; // res.all_keys_data = Array.from(new Set(res.all_keys_data))

                  res.all_keys_data.forEach(function (i) {
                    var checkpoint = i.substring(i.indexOf(':') + 1, i.indexOf(':', i.indexOf(':') + 1));
                    allData.push({
                      label: checkpoint,
                      value: 'n' + checkpoint,
                      tag: i
                    });
                  });
                  _this.totalDynamic = allData;
                  _this.totalDynamicValue = _this.Dynamic.map(function (item) {
                    return item.value;
                  });
                  res.data[_this.$t('total')] = total_data;
                  list = [];

                  for (key in res.data) {
                    data = {
                      date: key,
                      average: !res.data[key].total_task_pnum || !res.data[key].register_num ? 0 : (res.data[key].total_task_pnum / res.data[key].register_num).toFixed(2)
                    };

                    for (key1 in res.data[key][dataValue]) {
                      checkpoint = key1.substring(key1.indexOf(':') + 1, key1.lastIndexOf(':'));
                      data['n' + checkpoint] = dataValue == 'task_pnum' && _this.StatisticalContentValue == '1' ? res.data[key][dataValue][key1] || 0 : res.data[key][dataValue][key1] > 0 ? (res.data[key][dataValue][key1] * 100).toFixed(2) + "%" : '0%'; // if (Object.keys(res.data[key][dataValue]).length > this.Dynamic.length) {
                      //   this.Dynamic.push({
                      //     label: this.filterTaskDescDesc(checkpoint),
                      //     value: 'n' + checkpoint
                      //   })
                      // }
                    }

                    list.push(_objectSpread(_objectSpread({}, res.data[key]), data));
                  }

                  list.map(function (item, index) {
                    _this.Dynamic.forEach(function (items) {
                      item[items.value] = item[items.value] || (dataValue == 'task_pnum' && _this.StatisticalContentValue == '1' ? '0' : '0%');
                    });
                  });

                  if (_this.Dynamic.length) {
                    _this.Dynamic.push({
                      label: _this.$t('averageCheckpoint'),
                      value: 'average'
                    });
                  }

                  _this.$nextTick(function () {
                    _this.tableData = JSON.parse(JSON.stringify(list));
                  });

                  _this.$nextTick(function () {
                    _this.getTableRight();
                  }); // let dd = {
                  //   date: '总计',
                  // }
                  // this.Dynamic.forEach(item => {
                  //   dd[item.value] = dataValue == 'task_pnum' && this.StatisticalContentValue == '1' ? this.dataTalos(item.value) || 0 : (this.dataTalos(item.value) / this.tableData.length).toFixed(2) + "%"
                  // })
                  // dd.register_num = this.dataTalos('register_num')
                  // this.tableData.push(dd)


                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    filterTaskDescDesc: function filterTaskDescDesc(argument) {
      var index = this.TaskDescDescList.findIndex(function (item) {
        return item.task == argument;
      });
      return this.TaskDescDescList[index] ? this.TaskDescDescList[index].desc : argument;
    },
    dataTalos: function dataTalos(newValue) {
      var num = 0;
      var reg = new RegExp('%', 'g');
      this.tableData.forEach(function (item) {
        var k = item[newValue] ? JSON.parse(JSON.stringify(item[newValue]).replace(reg, '')) : 0;
        num += Number(k) || 0;
      });
      return num;
    },
    exportdata: function exportdata() {
      var d = {};
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.searchUserType,
        prop: 'register_num'
      }];
      var data = [];
      this.Dynamic.map(function (item) {
        columns.push({
          label: item.label,
          prop: item.value
        });
        d[item.value] = 0;
      });
      this.tableData.forEach(function (item) {
        var s = _objectSpread(_objectSpread({}, d), {}, {
          register_num: item.register_num
        });

        for (var key in s) {
          s[key] = item[key];
        }

        s.date = item.date;
        data.push(s);
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};